module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "stdreq"
    }
  }, [_c('stdreq-detail', {
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "data": _vm.index,
      "columns": _vm.columns[_vm.app.nowLang].index
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ba49ff80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stdreq/component.vue
// module id = 3963
// module chunks = 1